import { withPlatformImageAssetLoader } from '@mews-distributor/common';
import { PaymentMethodList as BasePaymentMethodList } from '@mews/business-components';
import { inject } from './inject';

export const PaymentMethodList = inject(withPlatformImageAssetLoader(BasePaymentMethodList));
